/**
 * Router handler for downgraded components
 *
 * This handles the routing with ui-router. By loading a downgraded component
 * as the single directive on the template we get the Angular component running
 * inside an AngularJS router
 *
 * @param $stateProvider - UI router state provider to handle states
 * @return void
 */
export default function RevertStatusRouter($stateProvider) {
  'ngInject';

  $stateProvider
    .state('app.revert-reservations-status', {
      url: '/merchants-revert-reservations-status',
      template: '<app-revert-reservations-status></app-revert-reservations-status>',
      data: {
        authorizedPermissions: ['MERCHANT_UPDATE'],
      },
    });
}


// WEBPACK FOOTER //
// ./src/app/merchants/revert-status/revert-status.router.ts